import { UserRolesEnum } from '../../auth/guards/roles.constants';
import { NavMenuItem } from '../models/NavMenuItem.model';
import { environment } from '../../environments/environment';

const APP_ITEMS = (env: string): NavMenuItem[] => [
  {
    name: 'INFRA - Infraestructura',
    path: `https://dso.volta${env}.sercide.com/`,
    rol: [UserRolesEnum.SABT_DISTRIBUTOR_ADMIN],
  },
  {
    name: 'ATR - Facturación',
    path: `https://atr.volta${env}.sercide.com/`,
    rol: [UserRolesEnum.SABT_DISTRIBUTOR_ADMIN],
  },
  {
    name: 'MDC - Captura de medidas',
    path: `https://mdc.volta${env}.sercide.com/`,
    rol: [UserRolesEnum.SABT_DISTRIBUTOR_ADMIN],
  },
  {
    name: 'RTB - Retribución',
    path: `https://rtb.volta${env}.sercide.com/`,
    rol: [UserRolesEnum.SABT_DISTRIBUTOR_ADMIN],
  },
  {
    name: 'MDM -  Medidas',
    path: `https://mdm.volta${env}.sercide.com/`,
    rol: [UserRolesEnum.SABT_DISTRIBUTOR_ADMIN],
  },
  {
    name: 'GIS',
    path: `https://gis${env !== '' ? 'pre' : ''}.sercide.com/apps/gis/`,
    rol: [UserRolesEnum.SABT_DISTRIBUTOR_ADMIN],
  },
];

const getEnvironmentSuffix = () => {
  const env = environment.environmentType;
  switch (environment.environmentType) {
    case 'dev':
      return '-desa';
    case 'prod':
      return '';
    default:
      return `-${env}`;
  }
};

export { APP_ITEMS, getEnvironmentSuffix };
